import type { AfterViewInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, isDevMode } from '@angular/core';

@Component({
  selector: 'app-metrika-counter',
  template: '<ng-container></ng-container>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MetrikaCounterComponent implements AfterViewInit {
  @Input() numberCounter: number;
  ngAfterViewInit(): void {
    if (!isDevMode()) {
      const script = document.createElement('script');

      script.innerHTML = `
          (function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * new Date();
    for (var j = 0; j < document.scripts.length; j++) {
      if (document.scripts[j].src === r) {
        return;
      }
    }
    (k = e.createElement(t)),
      (a = e.getElementsByTagName(t)[0]),
      (k.async = 1),
      (k.src = r),
      a.parentNode.insertBefore(k, a);
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

  ym(${this.numberCounter}, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
  });`;

      document.body.appendChild(script);
    }
  }
}
